import { render, staticRenderFns } from "./payment-history-bill.vue?vue&type=template&id=497109c4&scoped=true&"
import script from "./payment-history-bill.vue?vue&type=script&lang=js&"
export * from "./payment-history-bill.vue?vue&type=script&lang=js&"
import style0 from "./payment-history-bill.vue?vue&type=style&index=0&id=497109c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497109c4",
  null
  
)

/* custom blocks */
import block0 from "./payment-history-bill.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports